import Axios from 'axios';

export default async (user, email, assessments) => {
    const salesPerformance = { multiplyMetric: user.salesPerformance.multiplyMetric, ...user.salesPerformance };
    const userWithMetric = { ...user, salesPerformance };
    const body = { user: userWithMetric, email, assessments };

    return Axios.post('/email-value-report', body);
};